import Grid from "@mui/material/Grid2";
import Typography from "@mui/material/Typography";
import { observer } from "mobx-react-lite";
import React from "react";
import { Outlet } from "react-router-dom";
import { ProjectName } from "../constants/main";
import i18nStore from "../i18n/store";


const SignInPage = observer(() => {
    const translations = i18nStore.getTranslations;

    return (
        <Grid
            container
            spacing={2}
            direction="row"
            sx={{
                px: {xs: 0, md: 4, lg: 10 },
                justifyContent: "center",
                alignItems: "center",
                height: "calc(100vh - 250px)",
            }}
        >
            <Grid size={{ xs: 12, md: 6, lg: 5, xl: 4 }}>
                <Typography component="h1" variant="h5" sx={{ mb: 2 }}>
                    {ProjectName}
                </Typography>
                <Typography>
                    {translations.mainProjectDescription}
                </Typography>
            </Grid>
            <Grid size={{ xs: 12, md: 6, lg: 5, xl: 4 }}>
                <Outlet />
            </Grid>
        </Grid>
    );
});

export default SignInPage;
